// extracted by mini-css-extract-plugin
export default {"loading":"sectionLoader__loading__qojkE"};